var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isRouterAlive)?_c('Header',{attrs:{"flag":"true"}}):_vm._e(),_c('Menu',{attrs:{"showbg":"2"}}),(_vm.isRouterAlive)?_c('router-view',{key:_vm.$route.name}):_vm._e(),_c('Bottom'),_c('modules'),(_vm.$route.name!=='home')?_c('leftNav'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }